import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {bindActionCreators} from 'redux';
import lifecycle from 'recompose/lifecycle';
import {Redirect} from 'react-router-dom';
import {formDataManager} from 'hoc/formDataManager';
import {submitCreatePrize, endCreatePrizeAction} from './actions';
import CreatePrizeFormModal from 'components/prizes/CreatePrizeFormModal';
import createPrizeFormConfig from 'components/prizes/createPrizeFormConfig';

const mapStateToProps = state => ({
  modalOpen: state.createPrize.creatingPrize,
  creationError: state.createPrize.error
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onSaveData: data => submitCreatePrize(data.title, data.lang, data.prizeType),
  handleClose: endCreatePrizeAction
}, dispatch);

const CreatePrizeModalConnected = connect(mapStateToProps, mapDispatchToProps);

const CreatePrizeModalLifecycle = lifecycle({
  componentWillUnmount() {
    this.props.handleClose();
  }
});

const CreatePrizeModalResourceForm = formDataManager({
  title: '',
  lang: 'en-US',
  prizeType: 'RAFFLE'
}, createPrizeFormConfig);

const CreatePrizeModalRedirect = props => (
  <div>
    {props.createdPrizeId && (
      <Redirect to={`/prize/${props.createdPrizeId}/edit?openSection=editPrizeSection`} />
    )}
  </div>
);

const CreatePrizeModalRedirectContainer = connect(state => ({
  createdPrizeId: state.createPrize.createdPrizeId
}))(CreatePrizeModalRedirect);

const CreatePrizeModalContainer = compose(
  CreatePrizeModalConnected,
  CreatePrizeModalLifecycle,
  CreatePrizeModalResourceForm
)(CreatePrizeFormModal);

const CreatePrizeModalContainerFragment = () => (
  <Fragment>
    <CreatePrizeModalContainer key='CreatePrizeModalContainer' />
    <CreatePrizeModalRedirectContainer key='CreatePrizeModalRedirect' />
  </Fragment>
);

export default CreatePrizeModalContainerFragment;



// WEBPACK FOOTER //
// ./public/pages/PrizeCreator/CreatePrizeModalContainer.jsx